var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenFloorplan = function SvgOpenFloorplan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25292D",
    fillRule: "evenodd",
    d: "M37.343 33.924H29v-7.637a.5.5 0 1 0-1 0v6.008h-5.752a.5.5 0 0 0-.5.5v1.129H19.16v-9.108c0-.277-.223-.5-.5-.5h-2.91v-4.187h1.387a.5.5 0 0 0 0-1H15.75V13.87h4.524v5.758a.5.5 0 1 0 1 0V12h4.524v1.37a.5.5 0 0 0 .5.5h11.044v20.054zm-19.183 2.24H9V25.316h9.16v10.848zM9 24.316h5.75V13.872H9v10.444zM37.843 12.87H26.799V11.5a.5.5 0 0 0-.5-.5h-5.524a.5.5 0 0 0-.5.5v1.37H8.5a.5.5 0 0 0-.5.5v23.294a.5.5 0 0 0 .5.5h10.16c.277 0 .5-.223.5-.5v-1.74h3.088a.5.5 0 0 0 .5-.5v-1.13H28v1.13a.5.5 0 0 0 .5.5h9.343a.5.5 0 0 0 .5-.5V13.37a.5.5 0 0 0-.5-.5z"
  })));
};
export default SvgOpenFloorplan;